import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {take} from 'rxjs/operators';
import {AppComponent} from '../app.component';
import {Batiment} from '../Models/Batiment';
import {cloneDeep} from "lodash";
import {isSpecialPathForNewRefs} from "../helpers/user-ref.helper";
import {ROUTES_PATHS} from "../const/routes";
import {SiteKeyEnum} from "../enums/site-key.enum";

@Component({
	selector: 'app-estimation-rapide',
	templateUrl: './estimation-rapide.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./estimation-rapide.component.less']
})
export class EstimationRapideComponent implements OnInit {
	textes: any = "";
	globalTxt: any = "";
	modalsTxt: any = "";
	estimation: any;
	modalInfo: any;
	prestations: any = [];
	arrPieces = JSON.parse(localStorage.getItem("arrPieces")!);
	estimationRapide: any;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	//batSimId: any;
	//arrSimDetail: any;

	constructor(
		public app: AppComponent
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// ==> On remove du localstorage la modalOpen car c'est un ngInit
		if (localStorage.getItem("modalOpen") != null) localStorage.removeItem("modalOpen");

		this.app.confirmDialogService.getModalInfo().subscribe(modalInfo => {
			this.modalInfo = modalInfo;
			console.log("this.modalInfo ==> ", this.modalInfo);
			//this.modalInfo.noFn();
		});

		this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
			//console.log("opts ==> ", opts);
			this.prestations = cloneDeep(opts.tabsPrestations);
			if (this.prestations.length > 0) this.prestations = this.prestations.filter((presta: any) => {
				return presta.id != 99
			});
			//console.log("this.prestations", this.prestations);
		});


		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	showModalForSpecialPathsForNewRefs() {
		// Save in localStorage information to say that the modal has been shown
		localStorage.setItem('modalReturnToRooms', 'true');

		this.app.confirmDialogService.confirmThis(
			"",
			this.modalsTxt.modalGoToPieces,
			"confirm",
			"",
			() => {
				// Navigate to room page
				this.app.router.navigate([ROUTES_PATHS.PIECES]);
			},
			() => {
			}
		);
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get Simulation params by batiment
		this.getSimulationEstimation(this.batiment.simulationId!)

		// Get the modal texts
		this.app.dataInitService.getModalTextsOnce(modalsTxt => {
			this.modalsTxt = modalsTxt;
			console.log("this.modalsTxt ==> ", this.modalsTxt);

			// Show modal for special paths for new refs
			const _isSpecialPathForNewRefs: boolean = isSpecialPathForNewRefs(this.app.sharedToolsService);
			const modalReturnToRooms: boolean = localStorage.getItem('modalReturnToRooms') === 'true';
			// No "return to rooms" modal for the KTV_EXTERNAL referential
			const isKtvExternal: boolean = this.app.sharedToolsService.returnObjectSwitchRefId() === SiteKeyEnum.KTVEXTERNAL;

			if (_isSpecialPathForNewRefs && !modalReturnToRooms && !isKtvExternal) {
				this.showModalForSpecialPathsForNewRefs();
			}
		});


		// Get the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;
				});
			});
	}

	getSimulationEstimation(simId: string) {
		this.app.apiToolsService.getSimulationEstimation(simId).subscribe(res => {
			console.log("res getSimulationEstimation ==> ", res);
			this.estimationRapide = cloneDeep(res);

			this.app.sharedToolsService.getJSON("forFunctions").subscribe(data => {
				let fctGetPictoMenu = cloneDeep(data.fctGetPictoMenu);

				//console.log("fctGetPictoMenu ==> ", fctGetPictoMenu);

				this.estimationRapide.listRecapDetail.forEach((presta: any) => {
					presta.ListPieces.forEach((pic: any) => {
						let picto: any;
						picto = fctGetPictoMenu.filter((obj: any) => {
							return obj.picId == pic.RFP_ID;
						})[0];

						if (picto) pic.PIC_ICON = picto.icon;
					});
				});
			});
		});
	}

	onSubmit() {
		console.log(this.arrPieces);
		// ==> A voir comment on recupere les pieces, si par localstorgae ou par API getPieces.
		if (!this.arrPieces) return;

		let nextRoute = this.app.sharedToolsService.getRoutePath(this.textes.pathBtnSuivant);
		this.app.router.navigate([nextRoute + '/' + this.arrPieces[0].type + '/' + this.arrPieces[0].id]);
	}
}
